module.exports = __webpack_public_path__ + "img/chess_chinesechessred5.5a4114a5.png";